package com.macrofocus.eflux.ui.perspective

import com.macrofocus.common.properties.SimpleProperty
import com.macrofocus.eflux.DataLoader
import com.macrofocus.eflux.components.blurBackground
import com.macrofocus.eflux.toRawString
import com.macrofocus.eflux.ui.RowData
import com.macrofocus.high_d.table.DefaultTable
import com.macrofocus.high_d.table.ShowFilteredDataFrame
import emotion.react.css
import js.objects.unsafeJso
import kotlinx.browser.window
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import mui.x.GridColDef
import org.mkui.component.CPComponent
import org.mkui.react.useProperty
import org.molap.dataframe.DataFrame
import org.molap.json.readJson
import org.molap.questdb.readQuestDBJson
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useEffect
import react.useState
import web.cssom.*

class DataGridPerspective(private val dataLoader: DataLoader, url: String) : CPComponent {
    override val nativeComponent: FC<*> = FC<Props> {
        val theme = useTheme<Theme>()


        val customBackground: (SxProps<Theme>) -> Unit = { it ->
            it.blurBackground(theme)
        }

        Paper {
            sx = unsafeJso {
                position = Position.absolute
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                customBackground(this)
            }

            val theme = useTheme<Theme>()

            val customBackground: (SxProps<Theme>) -> Unit = { it ->
                it.blurBackground(theme)
            }

            var dataFrame by useState<DataFrame<Int, String, Any?>>()

            val (getShiftedDateTime, _) = useProperty(dataLoader.masterDateTime)
            val shiftedDateTime = getShiftedDateTime.toRawString()

            useEffect(shiftedDateTime) {
                val db = url.startsWith("db/")
                val input = if(db) {
                        "$url/$shiftedDateTime"
                    } else {
                        "$url?datetime=$shiftedDateTime"
                    }
                window.fetch(input).then {
                    it.text().then {
                        dataFrame = if(db) {
                            DataFrame.readQuestDBJson(it)
                        } else {
                            DataFrame.readJson(it)
                        }
                    }
                }
            }

            val rows = if (dataFrame != null) Array<RowData>(dataFrame!!.rowCount) { i ->
                unsafeJso<RowData> {
                    id = dataFrame!!.rowIndex.getKey(i)
                }
            } else emptyArray()

            val columns = if (dataFrame != null) Array<GridColDef>(dataFrame!!.columnCount) { i ->
                unsafeJso<GridColDef> {
                    field = dataFrame!!.columnIndex.getKey(i)
                    headerName = dataFrame!!.getColumnName(dataFrame!!.columnIndex.getKey(i))
//                    width = 200
                    valueGetter = { value, row, column, apiRef ->
                        if (row != null) {
                            val v = dataFrame?.getValueAt(row.id, dataFrame!!.columnIndex.getKey(i))
                            v
                        } else {
                            "null"
                        }
                    }
                }
            } else emptyArray()

            ReactHTML.div {
                css {
                    position = Position.relative
                    display = Display.flex
                    flexDirection = FlexDirection.column
                    minHeight = 0.px
                    width = 100.pct
                    height = 100.pct
                    maxHeight = 100.pct
//                    top = 0.px
//                    bottom = 0.px
//                    left = 0.px
//                    right = 0.px
//                    maxHeight = 100.vh

                    customBackground(this)
                }

                if(dataFrame != null) {
                    val table = DefaultTable<Int, String, Any?>()
                    table.dataFrame = ShowFilteredDataFrame<Int, String, Any?>(dataFrame!!, dataFrame!!, SimpleProperty(true))

                    table.nativeComponent()
                }

//                DataGrid {
//                    asDynamic().density = "compact"
//                    this.rows = rows
//                    this.columns = columns
////                pageSizeOptions = arrayOf(5)
//                    this.hideFooter = true
//                }
            }
        }
    }

}